
enum PricingStrategyRuleType {
	STATIC = 'STATIC', DYNAMIC = 'DYNAMIC'
}

export default PricingStrategyRuleType